export default "__VITE_ASSET__DR_kMyUF__"